// misc index.js

import buttons from './buttons' // Contains global button keys
import inputs from './inputs' // Contains global input keys and input rules

export default {
  ...buttons,
  ...inputs
}
